import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import RatingStars from 'tradera-components/rating-stars/rating-stars';
import ALink from 'tradera-components/alink/alink';

const getGaLinkAttributes = label => ({
    'data-ga-category': 'Top navigation',
    'data-ga-action': 'Account menu',
    'data-ga-label': `Link - ${label}`
});

const getGaButtonAttributes = label => ({
    'data-ga-category': 'Top navigation',
    'data-ga-action': 'Account menu',
    'data-ga-label': `Button - ${label}`
});

const ProfileCard = ({
    closeProfileMenu,
    memberAlias,
    memberId,
    rating,
    imageUrl,
    cleanedMemberAlias
}) => {
    const [imageAvailable, setImageAvailable] = useState(true);
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <div className="profile-card d-flex flex-column position-relative p-2">
            {imageUrl && imageAvailable && (
                <img
                    className="profile-card__image"
                    src={imageUrl}
                    alt="Profile image"
                    onError={() => {
                        setImageAvailable(false);
                    }}
                />
            )}
            <div className="profile-card__overlay" />
            <a
                className="profile-card__link position-relative btn btn-translucent align-self-end mb-auto"
                href={toLocalizedUrl('/my/settings/account')}
                {...(imageUrl
                    ? { ...getGaButtonAttributes('Change image') }
                    : { ...getGaButtonAttributes('Add image') })}>
                {imageUrl
                    ? t('siteHeader_changeCoverImage')
                    : t('siteHeader_addCoverImage')}
            </a>
            <ALink
                href={toLocalizedUrl(
                    `/profile/items/${memberId}/${cleanedMemberAlias}`
                )}
                useLink={true}
                onClick={closeProfileMenu}
                className="profile-card__link position-relative size-london mr-auto text-white font-weight-bold text-truncate"
                {...getGaLinkAttributes('My profile from header')}>
                {memberAlias}
            </ALink>
            {rating && (
                <div className="position-relative">
                    <RatingStars
                        memberAlias={cleanedMemberAlias}
                        memberId={memberId}
                        rating={rating}
                        gaAttributes={getGaLinkAttributes(
                            'My profile from header'
                        )}
                        onClick={closeProfileMenu}
                        link
                    />
                </div>
            )}
        </div>
    );
};

ProfileCard.propTypes = {
    memberAlias: PropTypes.string,
    memberId: PropTypes.number,
    rating: PropTypes.number,
    imageUrl: PropTypes.string
};

export default ProfileCard;
